import PageHeader from "@/components/PageHeader";
import Accessories from "@/components/Accessories";

export default function ZubehoerPage() {
  return (
    <>
      <PageHeader
        overline="Il Lusso della Vespa"
        title="Zubehör"
        accent="Deluxe."
        subtitle="Das Luxus-Upgrade für Ihren Auftritt — Helme, Leder, Merchandising, technisches Zubehör."
      />
      <Accessories />
    </>
  );
}
